import React from 'react'
import './SettingsPost.css'
import { useNavigate } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { Button } from '@mui/material'

function SettingsPost(props) {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const logout = () => {
        dispatch({
            type: 'SET_INITIAL_AUTH'            
        })
        localStorage.clear();       
        navigate("/")
    }
    return (
        <div className="surgesetting-items-container" onClick={() => props.text == "Logout" ? logout() : ""}>
            <Button>
                <img src={props.url} className="surgesettings-image-icon" alt='' />
                <div className="surgesettings-text">
                    <p>{props.text}</p>
                </div>
            </Button>
        </div>
    )
}

export default SettingsPost